import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgVesselPit = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 95.38,
	height: 55,
	viewBox: "0 0 95.38 55.0",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M 7.69 40.0 A 5.0 13.0 0.0 1 1 7.69 0.0 L 87.69 0.0 A 5.0 13.0 0.0 1 1 87.69 40.0 L 42.69 40.0 L 42.69 50.0 A 10.0 5.0 0.0 0 1 22.69 50.0 L 22.69 40.0 Z",
		fill: "none",
		stroke: "currentColor",
		strokeWidth: 1
	})
});
export default SvgVesselPit;
